"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupCurriculumCourseItem = exports.isGroupCurriculumSectionItem = exports.isGroupCurriculumFlatListElement = void 0;
var entityService_1 = require("./entityService");
var isGroupCurriculumFlatListElement = function (e) {
    return !!(e === null || e === void 0 ? void 0 : e.dragId);
};
exports.isGroupCurriculumFlatListElement = isGroupCurriculumFlatListElement;
var isGroupCurriculumSectionItem = function (e) {
    return (e === null || e === void 0 ? void 0 : e.type) === "section";
};
exports.isGroupCurriculumSectionItem = isGroupCurriculumSectionItem;
var isGroupCurriculumCourseItem = function (e) {
    return (e === null || e === void 0 ? void 0 : e.type) === entityService_1.corePaths.course;
};
exports.isGroupCurriculumCourseItem = isGroupCurriculumCourseItem;
